module.exports = __webpack_public_path__ + "media/entities/2310-eaa97bc1.png";